module.exports = __webpack_public_path__ + "static/media/backgammon.4fc4aa86.mp4";